
import { Box, TextField } from '@mui/material'
import React from 'react'
import styled from 'styled-components';
import { Label } from '../EditorViewStyles';

type Props = {
    placeholder: string,
    value: string,
    onChange: (ev: any) => void,
}


const StylingInput = styled("textarea")({
    outline: "none",
    border: "1px solid rgb(220, 220, 220)",
    width: "100%",
    fontSize: "12px",
    padding: '8px',
    color: "rgb(120, 120, 120)",
    resize: "none",
    marginBottom: "16px",
    backgroundColor: '#fff',

    "&:focus": {
        border: "1px solid rgb(180, 180, 180)",
    },

})

const CustomStylesUnput = ({ placeholder, value, onChange }: Props) => {
    return (
        <Box>
            <StylingInput
                rows={3}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
            />
        </Box>
    )
}

export default CustomStylesUnput